module.exports = __webpack_public_path__ + "media/flags/un-de98f1ac.svg";